export default __webpack_public_path__ + "assets/images/9b62afd8db8b563201fee2215ec0ef42.png";